<template>
  <div>
    <DocumentTitle activeClass="mb-3">회사 정보</DocumentTitle>
    <table class="creditor__table">
      <tr>
        <td>회사명</td>
        <td>
          <span class="seal-box">
            {{ organization.info.corpName }}
            <img :src="organization.info.corpSeal" />
          </span>
        </td>
      </tr>
      <tr>
        <td>대표이사</td>
        <td>{{ organization.info.ceoName }}</td>
      </tr>
      <tr>
        <td>사업자등록번호</td>
        <td>{{ organization.info.businessLicenseNumber }}</td>
      </tr>
      <tr>
        <td>주소</td>
        <td>{{ organization.info.address }}</td>
      </tr>
    </table>
     <v-row no-gutters class="agree mt-3">
      <v-col cols="8">
        <p class="mb-0">회사 정보에 대한 내용에</p>
      </v-col>

      <v-col cols="4" class="text-right">
        <button @click="isAgreed = !isAgreed" :class="{ active: isAgreed }">확인함</button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DocumentTitle from '@/components/documents/DocumentTitle.vue'

export default {
  components: {
    DocumentTitle,
  },
  data() {
    return {
      isAgreed: false,
    }
  },
  computed: {
    ...mapState('myfinbiz', ['organization']),
  },
  watch: {
    isAgreed(v) {
      this.$emit('emitAgreed', v)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.creditor {
  &__table {
    width: 100%;
    border-top: solid 1px #727d8c;
    border-collapse: collapse;

    tr {
      border-bottom: solid 1px #d7e1ea;
      td {
        height: 48px;
      }
      td:first-child {
        width: calc(136% / 325 * 100);
        background-color: #f4faff;
        font-weight: 600 !important;
        font-size: 15px !important;
        line-height: 2.13;
        text-align: center;
        color: $black;

        @media screen and (max-width: 350px) {
          font-size: 13px;
        }
      }
      td:last-child,
      td:last-child * {
        font-weight: 900 !important;
        font-size: 16px !important;
        line-height: 2;
        text-align: center;
        color: $black;

        @media screen and (max-width: 350px) {
          font-size: 14px;
        }
      }
    }
  }
}

.seal-box {
  position: relative;

  img {
    width: 80px;
    position: absolute;
    top: -32px;
    left: 40px;
  }
}
</style>
